import { PaginatedCustomersRequest } from "@admin/redux/api/Customer/type";
import { PaginatedData, User } from "@admin/types";
import api from "../index";

const CustomersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllCustomers: builder.query<
      PaginatedData<User>,
      PaginatedCustomersRequest
    >({
      query: (data) => ({
        url: "/admin/customer",
        method: "GET",
        params: data,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetAllCustomersQuery } = CustomersApi;
export default CustomersApi;
